import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { ExtendedRoute } from '@web/base';
import { Authentication, sessionStorageService, SIGNING_RETURN_PATH } from '@web/service';
import { LoginComponent } from './component/login.component';
import { SigningReturn } from './signing-return';

const redirectToAuthRoute: RedirectFunction = async redirectData => {
  const router = inject(Router);
  const externalId = redirectData.queryParams?.['externalId'];
  if (externalId) {
    return router.createUrlTree(['/auth/callback'], { queryParams: { externalId } });
  }
  return router.createUrlTree(['/auth/login']);
};

const redirectCallBack: RedirectFunction = async redirectData => {
  const router = inject(Router);
  const authService = inject(Authentication);
  const externalId = redirectData.queryParams?.['externalId'];
  const token = redirectData.queryParams?.['token'];
  const refreshToken = redirectData.queryParams?.['refreshToken'];
  try {
    await authService.completeLogin({ token, externalId, refreshToken });
    const redirectUrl = sessionStorageService.removeItem('redirectUrl')?.replaceAll('"', '') || '';
    return router.createUrlTree([`/${redirectUrl}`]);
  } catch (e) {
    console.error(e);
    return router.createUrlTree(['/auth/login'], { queryParams: { error: 'login_failed' } });
  }
};

export const AuthenticationRoutes: Record<string, ExtendedRoute> = {
  loginRedirect: { path: 'login', redirectTo: redirectToAuthRoute },
  intra: { path: 'intra', redirectTo: redirectToAuthRoute },
  login: { path: 'auth/login', component: LoginComponent },
  loginCallback: { path: 'auth/callback', redirectTo: redirectCallBack },
  signingReturn: { path: SIGNING_RETURN_PATH, component: SigningReturn },
};
